import { AuthContextProvider } from "context/AuthContext";
import { Layout } from "antd";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "components/PageHeader/PageHeader";
import { PaymentPageLoading } from "components/PageLoading/PaymentPageLoading";
import { getCredential } from "@vyne-shared/utils/getCredential";
import { usePatientTokenLogin } from "api/VynePayments/clients/usePatientTokenLogin";
import { useSentryUser } from "utils/initSentry";

const { Content } = Layout;

const AuthenticatedPatientPortal = () => {
    const initialCredential = Route.useParams();
    const credential = getCredential(initialCredential);
    const { data, isPending } = usePatientTokenLogin(credential);
    useSentryUser(data);

    return (
        <Layout>
            <PageHeader isPending={isPending} name={data?.customerName} logoUrl={data?.customerLogoUrl} />
            <Content className="content-container">
                {isPending || !data ? (
                    <PaymentPageLoading />
                ) : (
                    <AuthContextProvider value={{ ...data, token: credential?.token }}>
                        <Outlet />
                    </AuthContextProvider>
                )}
            </Content>
        </Layout>
    );
};

/** Route for authenticated Patient Portal functionality. */
export const Route = createFileRoute("/$token/$channel")({
    component: AuthenticatedPatientPortal,
});
